import { Pipe, PipeTransform } from '@angular/core';
import { ITableColumn } from '../../interfaces/i-table-column';
import { ColumnOption } from '../../interfaces/column-option';

@Pipe({
    name: 'formControl',
    standalone: false
})
export class FormControlPipe implements PipeTransform {

  transform(column: ITableColumn | ColumnOption, row: any) : boolean {
    return column.isFormControl;
  }

}
